import { jsx as o } from "react/jsx-runtime";
import i from "clsx";
import r from "./Select.module.css.js";
import { Dropdown as p } from "../../foundations/icons/Dropdown.js";
const s = ({
  className: n,
  innerProps: d,
  selectProps: t
}) => /* @__PURE__ */ o(
  "div",
  {
    ...d,
    className: i(
      {
        indicator: !0,
        "dropdown-indicator": !0,
        [r.dropdownIndicatorMenuOpen]: t.menuIsOpen
      },
      r.dropdownIndicator,
      n
    ),
    children: /* @__PURE__ */ o(p, {})
  }
);
export {
  s as DropdownIndicator
};
//# sourceMappingURL=DropdownIndicator.js.map
